import { imageDataHasSignatureInk } from '../domain/signatureInk.ts';

/** true = ink, false = blank canvas, null = blob could not be decoded for ink scan */
export async function blobHasSignatureInk(blob: Blob): Promise<boolean | null> {
  try {
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      bitmap.close();
      return null;
    }
    ctx.drawImage(bitmap, 0, 0);
    bitmap.close();
    return imageDataHasSignatureInk(ctx.getImageData(0, 0, canvas.width, canvas.height).data);
  } catch {
    return null;
  }
}

/** Fresh capture path: accept non-empty blob when ink scan is unreadable. */
export function signatureInkAcceptableForSave(blob: Blob, ink: boolean | null): boolean {
  if (ink === true) return true;
  if (ink === false) return false;
  return blob.size > 0;
}

export function signatureInkAssertError(ink: boolean | null, label: string): string {
  if (ink === null) return `${label} no se pudo verificar en el dispositivo.`;
  return `${label} está vacía o no se guardó en el dispositivo.`;
}
